export const providerContactData = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title: 'Have you already asked your provider to fix your poor speed?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/196e4facec80-tooliconwifi.jpg',
  },
}
